/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductTypeEnum } from '../../models/product-type-enum';

export interface ProductGetType$Json$Params {
  productId?: string;
}

export function productGetType$Json(http: HttpClient, rootUrl: string, params?: ProductGetType$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductTypeEnum>> {
  const rb = new RequestBuilder(rootUrl, productGetType$Json.PATH, 'get');
  if (params) {
    rb.query('productId', params.productId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductTypeEnum>;
    })
  );
}

productGetType$Json.PATH = '/api/Product/type';
